import trans from './trans';
import { logErrorMessage } from './errors';
import { isScrolledIntoView } from './helpers';
import * as notification from '../components/notifications';
const HTTP_FORBIDDEN            = 403;
const HTTP_NOT_FOUND            = 404;
const HTTP_PAYLOAD_TOO_LARGE    = 413;
const HTTP_PAGE_EXPIRED         = 419;
const HTTP_UNPROCESSABLE_ENTITY = 422;
const HTTP_TOO_MANY_REQUESTS    = 429;
const HTTP_INTERNAL_SERVER_ERROR= 500;

function getInputByError(errorKey, form){
  let input = !errorKey.includes('.')
    ? $(`[name=${errorKey}]`, form)
    : $(`#v-${errorKey}`.replaceAll('.', '-'), form);

  if (input.length) {
    const inputGroup = input.parent('.input-group');
    if (inputGroup.length) {
      input = inputGroup;
    }
  }

  return input.length ? input : null;
}

function scrollToFirstErrorInput(form) {
  let min = null;
  let $element = null;
  $('.is-invalid', form).each(function(){
    if(min === null || $(this).closest('.form-group').offset().top < min){
      min = $(this).closest('.form-group').offset().top
      $element = $(this).closest('.form-group');
    }
  });

  if ($element !== null && !isScrolledIntoView($element)) {
    let scrollTo = $element.offset().top;
    let headerNavBar = $('header .fixed-top');
    if (headerNavBar.length > 0) {
      scrollTo -= headerNavBar.height();
    }
    $([document.documentElement, document.body]).animate({
      scrollTop: scrollTo
    }, 500);
  }
}

export function resetFormErrors(form){
  $('.invalid-feedback', form).each(function(){
    const elem = $(this);
    if (!elem.hasClass('invalid-feedback-custom')) {
      elem.remove();
    }
  });
  $('.form-global-error', form).remove();
  $('.is-invalid', form).removeClass('is-invalid');
  $('.form-group-error', form).removeClass('form-group-error');
}

export function showInputError(input, message) {
  let errorContainer = input.closest('.form-group');
  if (!errorContainer.length) {
    errorContainer = input.parent('div');
  }

  const errorElement = $('<span class="invalid-feedback d-block"></span>');
  errorElement.text(message);

  errorContainer.append(errorElement);
  errorContainer.addClass('form-group-error');
  input.addClass('is-invalid');

  return errorContainer;
}

export function showErrorsNextToInputs(form, data) {
  let errors;
  let globalErrors = {};
  let input;
  let errorContainer;
  for (let errorKey in data.errors) {
    errors = data.errors[errorKey];

    input = getInputByError(errorKey, form);
    if (!input) {
      // @TODO: Show global errors
      globalErrors[errorKey] = errors;
      continue;
    }

    errorContainer = showInputError(input, errors[0]);
  }

  if (typeof errorContainer !== 'undefined' && errorContainer.length > 0) {
    scrollToFirstErrorInput(form);
  }

  if (Object.keys(globalErrors).length) {
    showFormErrorsOnTop(form, {data: {errors: globalErrors}});
  }
}

export function showFormErrorsOnTop(form, response){
  const {data} = response;
/*
  // For now I am disabling the form top errors, sicne we do not have proper design for it, all the errors will be show as notifications
  let errorsContainer = $('.form-global-errors-container', form);
  if (errorsContainer.length) {
    Object.entries(data.errors).forEach(([errorKey, errors]) => {
      const errorContainer = $('<li class="form-global-error" ></li>');
      errorContainer.text(errors[0]);

      errorsContainer.append(errorContainer);

      const input = getInputByError(errorKey, form);
      if (input) {
        input.addClass('is-invalid');
      }
    });
  } else {

  }
*/

  let errorMessage = '';
  Object.entries(data.errors).forEach(([errorKey, errors]) => {
    const message = errorMessage !== '' ? `\n ${errors[0]}` : errors[0];
    errorMessage += message;
  });

  notification.danger(errorMessage);


  // @TODO: This is temporary, just for some time to make sure we are not showing important errors at the top
  // of the application that a user can't do anything with
  logErrorMessage(errorMessage);
}

export function showFormErrors(form, response, {showOnTop = false} = {}) {
  const {status, data} = response;

  resetFormErrors(form);

  if (status === HTTP_PAGE_EXPIRED && data.message === 'current_employer_changed') {
    return;
  }

  if (status === HTTP_UNPROCESSABLE_ENTITY) {
    if (showOnTop) {
      showFormErrorsOnTop(form, response);
    } else {
      showErrorsNextToInputs(form, data);
    }
  } else if(status === HTTP_TOO_MANY_REQUESTS) {
    let message = 'Too many requests sent, please try again later!';
    if (data && data.message) {
      message = data.message;
    }
    notification.danger(message);
  } else if(status === HTTP_NOT_FOUND) {
    let message = 'The resource you are looking for is already deleted or does not exist.';
    if (data && data.message) {
      message = data.message;
    }
    notification.danger(message);
  } else if(status === HTTP_FORBIDDEN) {
    let message = 'Access Denied.';
    if (data && data.short_message) {
      message = data.short_message;
    }
    notification.danger(message);
  } else {
    notification.danger(
      "An application error has occurred, please reload the page and try again!"
    );
  }
}

export function getValidationErrorForLargeUploads(response, field) {
  const {status} = response;

  if (status !== HTTP_PAYLOAD_TOO_LARGE) {
    return response;
  }

  return {
    ...response,
    status: HTTP_UNPROCESSABLE_ENTITY,
    data: {
      errors: {
        [field]: [
          trans('validation.upload_size')
        ],
      },
    },
  };
}

/**
 * Refuses a picked image the API would refuse anyway, so a big file is not uploaded just to
 * be thrown away. The limits mirror the image module the field uploads to,
 * @see \JBoard\FieldManager\FormFieldImageModule::uploadLimits()
 *
 * @param {File} file
 * @param {{allowedMimeTypes: string[], maxFileSizeKb: number|null, invalidTypeMessage: string, tooLargeMessage: string}} limits
 * @returns {string|null} The message to show, or null when the file is fine. A limit that
 *                        is not given is not checked, the API stays the last word.
 */
export function getImageFileError(file, limits) {
  const {allowedMimeTypes = [], maxFileSizeKb = null, invalidTypeMessage, tooLargeMessage} = limits;

  if (allowedMimeTypes.length && !allowedMimeTypes.includes(file.type)) {
    return invalidTypeMessage;
  }

  /** Laravel validates the "max" rule in 1024-byte KB. */
  if (maxFileSizeKb && file.size > maxFileSizeKb * 1024) {
    return tooLargeMessage;
  }

  return null;
}

export function getFormData(form){
  const formData = $(form).serializeObject();

  // Since "serializeObject" does not return hidden recaptcha field, adding this code
  // as a workaround. Long term we need to understand if there is a core issue with it and fix it.
  const recaptchaResponseElement = $('[id^="g-recaptcha-response"]', form);
  if (recaptchaResponseElement.length) {
    formData['g-recaptcha-response'] = recaptchaResponseElement.val();
  }

  return formData;
}

export function showFormStatus(form, status, type = 'success'){
  resetFormStatus();

  const statusBox = $(`<div class="form-status jb-alert jb-alert-${type}" role="alert"></div>`);
  statusBox.text(status);

  $(form).prepend(statusBox);
}

export function resetFormStatus(form){
  $('.form-status', form).remove();
}

export function resetFormValues(form, controlSelectors){

  controlSelectors.forEach(selector => {
    $(selector, form).val('');
  })
}

export async function submitFormDataViaAPI(data, form, onSuccessEvent = null) {
  try{
    $('.btn-submit', form).loading(true);

    const formMethod = $(form).attr('method');
    const formAction = $(form).attr('action');

    let response;

    if (formMethod === 'PUT') {
      response = await axios.put(formAction, data);
    } else if (formMethod === 'PATCH') {
      response = await axios.patch(formAction, data);
    } else {
      response = await axios.post(formAction, data);
    }
    resetFormStatus(form);
    resetFormErrors(form);
    $('.btn-submit', form).loading(false);

    if (response.data.status) {
      showFormStatus(form, response.data.status);
      $('.btn-submit', form).prop("disabled",true);
    } else if (form.data('success-redirect')) {
      if (onSuccessEvent) {
        onSuccessEvent(response.data);
      }
      const redirectUrl = form.data('success-redirect');

      window.location.replace(redirectUrl);
    }
  } catch (e) {
    resetFormStatus(form);
    if (e.response.data.status) {
      showFormStatus(form, e.response.data.status, 'danger');
    }
    showFormErrors(form, e.response);
    $('.btn-submit', form).loading(false);
  }
}
